import {
  GetHiringStagesDocument,
  SwapHiringStagePositionsDocument,
  SwapHiringStagePositionsMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useSwapHiringStagePositions = () => {
  const [swapPositionsAtsHiringStage, { loading }] = useMutation(SwapHiringStagePositionsDocument, {
    extractorFn: (data: SwapHiringStagePositionsMutation) =>
      data.atsMutations.swapPositionsAtsHiringStage,
  })

  return {
    loading,
    swapPositionsAtsHiringStage(atsHiringStageIdOne: number, atsHiringStageIdTwo: number) {
      return swapPositionsAtsHiringStage({
        variables: { atsHiringStageIdOne, atsHiringStageIdTwo },
        refetchQueries: [GetHiringStagesDocument],
      })
    },
  }
}
